import React, { useEffect, useState, useMemo } from "react";
import clsx from "clsx";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../../_core/MetronicLayout";
import { SearchResult } from "./SearchResult";
import { toAbsoluteUrl } from "../../../../../_helpers";
import { useSelector, shallowEqual } from "react-redux";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

export function SearchDropdown({ onClose }) {
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  let timeoutId;

  const clearTimeout = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = undefined;
    }
  };

  const handleSearchChange = async (event) => {
    event.preventDefault();

    setData(null);
    setSearchValue(event.target.value);

    if (event.target.value.length > 2) {
      setLoading(true);

      const PRODUCTS_URL = "https://graphql.brandsolo.com/v1/graphql";
      const result = await fetch(
        PRODUCTS_URL , {
          method: "POST",
          body: JSON.stringify({
            query: `
              query brandSoloQuery($name: String!, $client: Int!) {
                product(where: {active: {_eq: 1}, brand: {client_id: {_eq: $client}}, name: {_ilike: $name}}) {
                  id,
                  name,
                }
                brand(where: {client_id: {_eq: $client}, name: {_ilike: $name}}) {
                  id,
                  name
                }
                seller(where: {link: {product: {brand: {client_id: {_eq: $client}}}}, seller_name: {_ilike: $name}}) {
                  id,
                  name: seller_name,
                  platform {
                    domain
                  }
                }
              }
            `,
            variables: {
              name:`%${event.target.value}%`,
              client: user.client.id
            }
          })
        }
      );

      const json = await result.json();
      const array = [];
      Object.keys(json.data).forEach((type) => {
        if (json.data[type].length > 0) {
          array.push({
            type: 0,
            text: type,
          });
          json.data[type].forEach((item) => {
            array.push({
              id: item.id,
              type: type,
              text: item.name,
              description: "",
              extra: item.platform ? item.platform.domain : "",
              iconImage: toAbsoluteUrl("/media/files/doc.svg"),
            });
          });
        }
      });

      setData(array);
      setLoading(false);
    }
  };

  const clear = () => {
    setData(null);
    setSearchValue("");
  };

  const close = () => {
    setData(null);
    setSearchValue("");
    onClose();
  }

  useEffect(() => {
    return () => {
      clearTimeout();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.search.layout") ===
        "offcanvas",
    };
  }, [uiService]);

  return (
      <>
        {layoutProps.offcanvas && (
          <div className="topbar-item">
            <div
              className="btn btn-icon btn-clean btn-lg mr-1"
              id="kt_quick_search_toggle"
            >
              <span className="svg-icon svg-icon-xl svg-icon-primary">
                <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
              </span>
            </div>
          </div>
        )}
        {!layoutProps.offcanvas && (
         <ClickAwayListener onClickAway={() => clear()}>
          <div
            id="kt_quick_search_dropdown"
            className={clsx("quick-search quick-search-dropdown", {
              "quick-search-has-result": data && data.length,
            })}
          >
            <form className="quick-search-form">
              <div className="input-group">
                <div className={`input-group-prepend`}>
                  <span className="input-group-text">
                    <span className="svg-icon svg-icon-lg">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Search.svg"
                        )}
                      />
                    </span>
                  </span>
                </div>
                <input
                  type="text"
                  autoFocus={true}
                  placeholder="Search..."
                  value={searchValue}
                  onChange={handleSearchChange}
                  onKeyDown={(e) => e.key === 'Enter' ? e.preventDefault() :  true}
                  className="form-control"
                  style={{ fontSize: "2em", color: "#fff" }}
                />

                <div
                  className={`input-group-append ${
                    loading ? "spinner spinner-sm spinner-primary" : ""
                  }")}`}
                >
                  <span className="input-group-text">
                    <i
                      style={{
                        display:
                          (loading || !data)
                            ? "none"
                            : "none",
                      }}
                      onClick={clear}
                      className="quick-search-close ki ki-close icon-sm text-muted"
                    />
                  </span>
                </div>
              </div>
            </form>
            <div className="p-0 m-0 dropdown-menu-anim-up show">
              <SearchResult onClickLink={() => close()} data={data} />
            </div>
          </div>
         </ClickAwayListener>
        )}
      </>
  );
}
